import Image from "apps/website/components/base/Image/Image";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import Column from "apps/website/components/layout/Column/Column";
import Container from "apps/website/components/layout/Container/Container";
import Grid from "apps/website/components/layout/Grid/Grid";
import Section from "apps/website/components/layout/Section/Section";
import { themeRootClassMap } from "apps/website/maps/Theme.map";
import cx from "apps/website/utils/misc/cx";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import Icon from "apps/website/components/base/Icon/Icon";

import { sectionThingsEveryParentShouldKnowData } from "./data";

export default function SectionThingsEveryParentShouldKnowVariant() {
  return (
    <Section theme="light-grey-75" className={themeRootClassMap["light-grey-75"]}>
      <Container>
        <Grid gap="lg">
          <Column align="center" justify="center">
            <TextTitle
              tag="h2"
              size={1}
              align="center"
              className="sr-only"
            >4 things every cat parent should know about cat food:</TextTitle>
          </Column>
        </Grid>
        <Grid gap="xl">
          <Column spans={{ xl: 6 }} align="center" justify="center">
            <Image image={{
              src: "/images/landingPage/things-every-cat-parent-should-know/4-things-every-cat-parent-should-know.webp",
              width: 1000,
              height: 1000,
            }}
            alt="4 things every cat parent should know about cat food"
            />
          </Column>
          <Column spans={{ xl: 6 }}>
            <Grid gap="none" tag="ol" className={cx(
              themeRootClassMap["light-grey"],
              "xl:p-4",
            )}>
              <>
                { sectionThingsEveryParentShouldKnowData.items.map((item) => (
                  <Column key={item.title} tag="li" spans={{ xl: 6 }} className="p-4 pb-0 last:pb-4 xl:p-3 xl:pb-3">
                    <div data-theme="light-grey" className={
                      cx(
                        "flex xl:flex-col space-x-4 xl:space-y-2",
                      )
                    }>
                      <div className="max-w-[48px] xl:max-w-[64px]">
                        <Image image={item.image} alt="" />
                      </div>
                      <div className="flex flex-col space-y-2">
                        <TextSubtitle size={2}>{ item.title }</TextSubtitle>
                        <TextBody size={3}>{ item.body }</TextBody>
                      </div>
                    </div>
                  </Column>
                )) }
              </>
            </Grid>
            <div className="py-6 lg:py-4">
              <Grid>
                <Column spans={4} align="center" justify="center">
                  <Icon icon="catDisappointed" size="fit" />
                </Column>
                <Column spans={8} align="center" justify="center">
                  <div
                    data-theme="dark"
                    className={
                      cx(
                        themeRootClassMap.dark,
                        "p-2 -rotate-1",
                      )
                    }
                  >
                    <TextSubtitle size={2} color="default">
                      The result?  Fussy, unsatisfied cats. Who turn their nose up at mealtimes or beg between feeds.
                    </TextSubtitle>
                  </div>
                </Column>
              </Grid>
            </div>
          </Column>
        </Grid>
        <Grid>
          <Column justify="center">
            <TextSubtitle align="center">Pspsps... Sound familiar? Keep reading.</TextSubtitle>
          </Column>
        </Grid>
      </Container>
    </Section>
  );
}
